export default __webpack_public_path__ + "static/media/zoneIconPersonal.1b121bc5.svg";